/**
 * Converte o um boolean para o status enum.
 */
export const convertBooleanToStatus = (value) => {
    if (value) {
        return "ACTIVE";
    }
    return "INACTIVE";
}

/**
 * Converte o status enum para um boolean.
 */
export const convertStatusToBoolean = (value) => {
    if (value === "ACTIVE") {
        return true;
    }
    return false;
}

export const convertYesOrNoToBoolean = (value) => {
    if (value === "Y") {
        return true;
    }
    return false;
}

export const convertBooleanToYesOrNo = (value) => {
    if (value) {
        return "Y";
    }
    return "N";
}

/**
 * Formata um valor em String para o formato Double.
 */
export const convertStringToStringDouble = (value) => {
    if (value != null) {
        value = String(value);

        return value.replace(",", ".");
    }

    return "";
}

// Formatar um double no formato do país.
export const convertDoubleToStringPTBR = (value) => {
    if (value != null) {
        const numericValue = Number(value); // Converte para número caso seja string
        return numericValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    return value;
}

// Valor em reais com o símbolo e sempre com centavos: "R$ 226.009,93". Dinheiro não é
// arredondado na tela: o número é conferido contra o caixa e o DRE, e "R$ 226.010" num lugar
// com "226.009,93" no outro parece diferença onde não há.
export const convertDoubleToCurrencyPTBR = (value) => `R$ ${convertDoubleToStringPTBR(Number(value || 0))}`;

export const convertQuantityToStringPTBR = (value) => {
    if (value != null) {
        const numericValue = Number(value); // Converte para número caso seja string
        
        // Verifica se o número tem casas decimais
        if (!Number.isInteger(numericValue)) {
            return numericValue.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
        }

        return numericValue.toString(); // Retorna como string sem formatação extra
    }

    return value;
};

// Converte um array buffer em um blob.
export const convertArrayBufferToBlob = (data) => {
    // Convertendo os bytes da imagem para uma URL de objeto 
    const blob = new Blob([data]);
    return URL.createObjectURL(blob);
}

export const convertUrlObjectToFile = async (urlObject, fileName) => {
    const response = await fetch(urlObject);
    const blob = await response.blob();
    return new File([blob], fileName, { type: blob.type });
}

/**
 * Converte o Sexo para o id de tradução corresponde.
 */
export const convertGenderToTranslationId = (value) => {
    if (value === "M") {
        return "masculine";
    }
    return "feminine";
}

export const getBillingCycleName = (months) => {
    const billingCycles = {
        1: "MONTHLY",
        2: "BIMONTHLY",
        3: "QUARTERLY",
        6: "SEMI_ANNUAL",
        12: "YEARLY",
        24: "BIENNIAL"
    }

    return billingCycles[months] || "UNKNOWN";
}